import React, { Component } from 'react'
import "./NotFound404.css"

export class NotFound404 extends Component {
    render() {
        return (
            <div id="not-found-page">
                
                <p>404 | Not Found</p>
            </div>
        )
    }
}

export default NotFound404;

